<template>
  <div class="md-layout">
    <div class="md-layout-item md-layout md-size-66">
      <div class="md-layout-item md-size-100">
        <issue-cliente :issue="issue" />
      </div>
      <div class="md-layout-item md-size-100">
        <issue-productos-afectados :issue="issue" />
      </div>

      <div class="md-layout-item md-size-100">
        <issue-comments :issue="issue" />
      </div>
      <div v-if="show_photo" class="photo-viewer">
        <!-- <div class="photo-wrapper"> -->
        <div class="photo-container">
          <md-button class="md-button md-round md-warning photo-button" @click="closeImage()">Cerrar</md-button>
          <img :src="selected_image" />
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="md-layout-item md-size-33 md-gutter">
      <div class="md-layout-item md-size-100 div-info">
        <div style="display:flex">
          <issue-status :issue="issue"></issue-status>
        </div>
      </div>
      <div class="md-layout-item md-size-100 div-info">
        <label>Fecha: {{ getDateString(issue.created_at)}}</label>
      </div>
      <div class="md-layout-item md-size-100 div-info" v-if="issue.timeline != null">
        <issue-time-line :issue="issue" />
      </div>
      <!--<div class="md-layout md-layout-item md-size-100 div-info">
        <h5>Imágenes</h5>
        <div class="photos md-layout md-layout-item md-size-100">
          <img
            class="issue-photo md-layout-item md-size-25"
            :src="getIssueImageUrl(photo.idFoto)"
            v-for="(photo) in issue.productos"
            :key="photo.idFoto"
            @click="showImage(photo.idFoto)"
          />
        </div> 
      </div>-->
    </div>
  </div>
</template>
<script>
import { Badge, TimeLine, TimeLineItem, SectionPanel } from "@/components";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import IssueStatus from "./components/IssueStatus";
import IssueTimeLine from "./components/IssueTimeLine";
import IssueComments from "./components/IssueComments";
import IssueCliente from "./components/IssueCliente";
import IssueProductosAfectados from "./components/IssueProductosAfectados";

export default {
  name: "issue-modal-cliente",
  components: {
    Badge,
    TimeLine,
    TimeLineItem,
    SectionPanel,
    IssueStatus,
    IssueTimeLine,
    IssueComments,
    IssueCliente,
    IssueProductosAfectados
  },
  props: {
    issue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      new_comment: "",
      user: "",
      show_photo: false,
      selected_image: ""
    };
  },
  methods: {
    closeissueView() {
      this.$emit("close");
    },
    getIssueImageUrl(image_file) {
      return staticServer + "reclamaciones/" + image_file;
    },
    showImage(photo) {
      this.show_photo = true;
      this.selected_image = staticServer + "reclamaciones/" + photo;
    },
    closeImage() {
      this.show_photo = false;
      this.selected_image = "";
    },
    getDateString(value) {
      if (value != null) {
        let d = new Date(value);
        return d.toLocaleString("es-ES", { timeZone: "Europe/Madrid" });
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  max-width: 900px !important;
}
.modal-body {
  height: 500px !important;
  overflow-y: auto !important;
}
.issue-photo {
  width: 55px;
  height: 55px;
  padding: 0% !important;
  cursor: pointer;
}
.photos {
  padding-top: 20px !important;
  display: flex;
  justify-content: space-between;
}
.photo-viewer {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
  align-items: center;
  justify-content: center;
}
.photo-wrapper {
  display: inline;
  vertical-align: middle;
}
.photo-container {
  display: block;
  max-width: 900px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  height: fit-content;
  max-height: 100%;
  overflow: auto;
}
.photo-container > img {
  padding: 10px;
}
.photo-button {
  top: 20px;
  float: right;
  position: absolute;
  right: 20px;
}
</style>
